import { Button, Menu, MenuItem } from "@mui/material";
import { PLAYBACK_SPEED_OPTION, PLAYBACK_SPEED_OPTIONS } from "../../Video/VideoPlayer";
import { useState, MouseEvent } from "react";

export type PlaybackControlProps = {
  playbackSpeed: PLAYBACK_SPEED_OPTION;
  setPlaybackSpeed: (speed: PLAYBACK_SPEED_OPTION) => void;
};

export default function PlaybackSpeedControl({
  playbackSpeed,
  setPlaybackSpeed,
}: PlaybackControlProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectRate = (speed: PLAYBACK_SPEED_OPTION) => {
    setPlaybackSpeed(speed);
    handleClose();
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        size="small"
        onClick={handleClick}
        aria-haspopup="true"
        aria-controls={open ? "playback-speed-menu" : undefined}
        sx={{
          borderRadius: "50%",
          height: 36,
          width: 36,
          minWidth: 0,
          p:1
        }}
      >
        {playbackSpeed}x
      </Button>
      <Menu open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {PLAYBACK_SPEED_OPTIONS.map((speed) => (
          <MenuItem
            key={speed}
            selected={speed === playbackSpeed}
            onClick={() => handleSelectRate(speed)}
          >
            {speed}x
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
